import {CombinedApiResponse, doApiRequest, Method, Module} from '@/api';
import {parseGenericFilters} from '@/api/meta/filters';
import {NVESearch} from '@/model/NVE';

export enum ResourceNVE {
  NVE = '/NVE',
}

export async function searchNVE(
    nve: string,
    limit: number | null = null, skip: number = 0,
): Promise<NVESearch | null> {
  const parsedFilters = parseGenericFilters({
    NVE: nve,
    Erledigt: 'N',
  });
  const response = await doApiRequest({
    method: Method.Get,
    resource: ResourceNVE.NVE,
    module: Module.NVE,
    filters: parsedFilters,
    skip,
    limit,
  });

  return response.Data.length > 0 ? {
    Chargennr: response.Data[0].Chargen[0]?.ChargenNr ?? '',
    Datum: response.Data[0].Datum,
    Lagerfach: response.Data[0].LagerDaten.Lagerfach,
    Lagerhalle: response.Data[0].LagerDaten.Lagerhalle,
    NVE: response.Data[0].NVE,
    Niederlassung: response.Data[0].LagerDaten.Niederlassung,
    Restmenge: response.Data[0].Restmenge,
    ArtikelNr: response.Data[0].ArtikelDaten.ArtikelNr,
  }: null;
}
